import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import { useTrack } from '../../../../products/WLC/contexts/TrackContext';
import { useWLC } from '../../../../products/WLC/contexts/WLCContext';
import { height } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';

const GettingStartedTrackList = () => {
  const { trackList } = useTrack();
  const { wlcProgress } = useWLC();
  const trackOrder = wlcProgress?.trackPriorityOrder ?? [];
  const sortedTrackList = [...trackList]
    .filter(v => !v.hidden && trackOrder.indexOf(v.slug) !== -1)
    .sort((a, b) => {
      return trackOrder.indexOf(a.slug) - trackOrder.indexOf(b.slug);
    });
  const nextTrackTitle = sortedTrackList?.[0]?.title;

  console.log('SORTED TRACK LIST: ', sortedTrackList);
  return (
    <Container>
      <Row>
        <Col>
          <h3>Your 8-Week Health Track</h3>
          <p>
            You selected a focus area when you joined:
            <br />
            <strong>{nextTrackTitle}</strong>
          </p>
          <p>Your first 8 weekly guides will be curated around this topic, building week over week.</p>
          <p>After you complete your first 8 weeks, you’ll automatically start your next track.</p>
          <p>
            Your subsequent tracks are recommended based on your preferences. You’ll be able to update your track plan
            any time after week 1 starts.
          </p>
          <p>Here’s what each track covers:</p>
        </Col>
      </Row>
      <Row>
        {sortedTrackList.map((track, idx) => (
          <Col xs="12" md="6" lg="4" key={track.slug} className="mb-4">
            <Card className="background-light-purple" style={{ height: '100%' }}>
              <CardBody className="align-items-center">
                <Row className="align-items-center">
                  <Col xs="3">
                    {track.image ? (
                      <img src={track.image.url} alt={track.image.alt} className="wlcTrackWeekIcon" />
                    ) : (
                      <div className="wlcTrackWeekIcon wlcTrackIconFallback d-inline-block" aria-hidden="true" />
                    )}
                  </Col>
                  <Col xs="9">
                    {idx === 0 ? (
                      <p className="mb-2">
                        <em>Your Selected Health Track</em>
                      </p>
                    ) : null}
                    <h4 className="my-0">{track.title}</h4>
                    <p className="mb-0">{track.description}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default GettingStartedTrackList;
